import { ComposeStore } from '@sendible/shared-state-bridge';

export const COMPOSE_TABS = {
  MESSAGE: 'message',
  TWITTER: 'x',
  FACEBOOK: 'facebook',
  GOOGLE_MY_BUSINESS_LOCATION: 'googlemybusinesslocation',
  LINKEDIN: 'linkedin',
  PINTEREST: 'pinterest',
  TIKTOK: 'tiktok',
  INSTAGRAM: 'instagram',
  BLUESKY: 'bluesky',
  THREADS: 'threads',
  YOUTUBE: 'youtube',
  WORDPRESS: 'wordpress',
  GROUP: 'group',
  // NOTE: not a real network - a pseudo tab reused by the bulk importer so it can
  // drive the same media attach dropdown/upload pipeline as the compose box tabs.
  BULK_IMPORT: 'bulkImport',
} as const;

export const defaultCompose: ComposeStore = {
  activeComposeBoxTab: 'message',
  tabsState: { message: { postType: 'post' } },
  isComposeBoxOpen: false,
  isMediaAttacherOpen: false,
};

export const ALT_TEXT_DEFAULT_LIMIT = 200;
export const ALT_TEXT_CHAR_LIMITS = {
  [COMPOSE_TABS.MESSAGE]: 200,
  [COMPOSE_TABS.INSTAGRAM]: 200,
  [COMPOSE_TABS.LINKEDIN]: 200,
  [COMPOSE_TABS.TWITTER]: 200,
};

export const MAX_MEDIA_LIMIT = 40;
// The bulk importer attaches exactly one media item per row.
export const BULK_IMPORT_MAX_MEDIA = 1;
export const VALIDATION_DEBOUNCE_MS = 800;
